import React from "react";
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import ShipmentsListPage from "./shipments-list-page/shipments-list-page";
import FontBody1 from "../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../components/fonts/font-props";
import AHref from "../../components/ahref/ahref";
import "./shipments-page.scss";
import Banner, { BANNER_VARIANT } from "../../components/banner/banner";
import ResolveCapability from "../../components/resolve-capability/resolve-capability";
import { PROFILE_CAPABILITIES } from "../../models/ProfileCapabilities";

const ShipmentsPage: React.FC = () => {

	return (
		<BasePageLayout
			title={'Return Shipments'}
			instruction={
				<>
					<FontBody1>Track and view all of your return shipments in one place, gain visibility into their
						statuses, and </FontBody1>
					<br/>
					<FontBody1>monitor return label costs.</FontBody1>
					<AHref href="https://support.returngo.ai/tracking-shipments" target="_blank">
						<FontBody1 variant={FONT_VARIANT.UNDER_LINE}>Learn More</FontBody1>
					</AHref>
				</>
			}
		>
			<ResolveCapability capability={PROFILE_CAPABILITIES.SBR}>
				{({isSupported}) => isSupported && (
					<div className="shipments-banners">
						<Banner
							variant={BANNER_VARIANT.VARIANT_1}
							content={
								<>
									<FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
										Shipment Data May Be Incomplete
									</FontBody1>
									<br/>
									<FontBody1 color={FONT_COLOR.PRIMARY2}>If you are not yet using </FontBody1>
									<AHref href="https://returngo.ai/ship-by-returngo/" target="_blank">
										<FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.UNDER_LINE}>Ship by
											ReturnGO</FontBody1>
									</AHref>
									<FontBody1 color={FONT_COLOR.PRIMARY2}>, you may see limited data in this
										table.</FontBody1>
								</>
							}
						/>
						<Banner
							variant={BANNER_VARIANT.VARIANT_2}
							content={
								<>
									<FontBody1 color={FONT_COLOR.PRIMARY2}>Did you know? Ship by ReturnGO </FontBody1>
									<FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>automatically
										cancels unused labels</FontBody1>
									<FontBody1 color={FONT_COLOR.PRIMARY2}>, helping you save significantly on return
										costs. </FontBody1>
									<AHref href="https://returngo.ai/ship-by-returngo/" target="_blank"> <FontBody1
										color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.UNDER_LINE}>Read more about
										Ship By ReturnGO</FontBody1></AHref>
									<FontBody1 color={FONT_COLOR.PRIMARY2}> or </FontBody1>
									<AHref href="https://meetings.hubspot.com/returngo/onboarding-session"
									       target="_blank"> <FontBody1 color={FONT_COLOR.PRIMARY2}
									                                   variant={FONT_VARIANT.UNDER_LINE}>book a demo
										with us</FontBody1></AHref>.
								</>
							}
						/>
					</div>
				)}
			</ResolveCapability>

			<div className="shipments-page">
				<ShipmentsListPage/>
			</div>
		</BasePageLayout>
	)
};

export default ShipmentsPage;
